var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5131 4.24281L14.6811 3.07468C15.3263 2.42953 16.3723 2.42953 17.0175 3.07468C17.6626 3.71982 17.6626 4.7658 17.0175 5.41094L15.8493 6.57908M13.5131 4.24281L9.15147 8.6044C8.28041 9.47549 7.84485 9.91098 7.54828 10.4417C7.25169 10.9725 6.9533 12.2257 6.66797 13.4242C7.86638 13.1388 9.11964 12.8404 9.65039 12.5438C10.1811 12.2472 10.6166 11.8117 11.4877 10.9407L15.8493 6.57908M13.5131 4.24281L15.8493 6.57908",
    stroke: "#FF5C3C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.0908C17.5 13.6263 17.5 15.3942 16.4017 16.4925C15.3033 17.5908 13.5355 17.5908 10 17.5908C6.46447 17.5908 4.6967 17.5908 3.59835 16.4925C2.5 15.3942 2.5 13.6263 2.5 10.0908C2.5 6.55529 2.5 4.78752 3.59835 3.68917C4.6967 2.59082 6.46447 2.59082 10 2.59082",
    stroke: "#FF5C3C",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierPencilEdit);
export default __webpack_public_path__ + "static/media/supplier-pencil-edit.04de56b5551a4fe73e50d4bed6574ce9.svg";
export { ForwardRef as ReactComponent };